import AxiosClient from '../../../functional/Axios/AxiosClient';

export const emrRecordsApi = {
  emrRecordsGet: ({ query }) => AxiosClient.get(`/emrRecords?${query}`),

  emrRecordCreate: (data) => AxiosClient.post('/emrRecords/', data),

  emrRecordUpdate: (data) => AxiosClient.put('/emrRecords/', data),
};
